import {hasFeatureFlag} from '../../forecast-app/shared/util/FeatureUtil';
import {hasPermission, isClientUser} from '../../forecast-app/shared/util/PermissionsUtil';
import {PERMISSION_TYPE} from '../../Permissions';

/** Gate for the AI report builder: both feature flags, INSIGHTS_READ, and not a client user. Shared
 * by the chat entry point, the route, and the page so the gate lives in one place.
 *
 * The client-user exclusion mirrors `canUseAgentChat`, so the builder and the agent state one
 * entitlement rather than two. The other half of that rule — excluding collaborator seats — is not
 * applied here: it needs a viewer's profiles, and none of this gate's call sites has them. For the
 * chat route it is already enforced upstream, since the drawer renders nothing for a collaborator.
 * What remains reachable is a collaborator holding INSIGHTS_READ re-opening an existing AI report
 * from the reports list, which the backend now serves rather than failing. */
export function canOpenReportBuilder(): boolean {
	return (
		hasFeatureFlag('ai_report_builder') &&
		hasFeatureFlag('forecast_agent_chat') &&
		hasPermission(PERMISSION_TYPE.INSIGHTS_READ) &&
		!isClientUser()
	);
}
